import { Flex, IconChevronDown, Typography, Colors } from '@banhala/ui-kit';
import type { RankingFilterAge } from 'shared/src/api';

interface AgeFilterProps {
  selectedAge: RankingFilterAge | null;
  onPress: () => void;
}

export const AgeFilter = ({ selectedAge, onPress }: AgeFilterProps) => {
  const displayName = selectedAge?.name ?? '전체 연령';

  return (
    <Flex.Row
      alignItems="center"
      gap={4}
      padding={{ horizontal: 16, vertical: 2 }}
      onPress={onPress}
      testID={`연령필터-${displayName}`}
    >
      <Typography type="body2" color="content_primary">
        {displayName}
      </Typography>
      <IconChevronDown size={14} fill={Colors.content_secondary} />
    </Flex.Row>
  );
};
